import $ from "jquery";
import 'moment-timezone';
import React, { useState, useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import Moment from 'react-moment';
import SessionManager from '../../routes/SessionManager';
import LiveCameraFeed from '../modals/LiveCameraFeed';
import no_image from './../../assets/img/no-image.png';
import default_preset from './../../assets/img/default-view.png';
import CommonUtils from '../../util/CommonUtils';
import { Badge, Popover, Modal } from "antd";
import AxisLiveCameraFeed from "../modals/AxisLiveCameraFeed";
import LZString from 'lz-string';
import Toastr from 'toastr';

function ZoneCard(props) {

  let sessionMgr = new SessionManager();
  const imageRef = useRef(null);
  const [isFavourite, setFavorite] = useState(props.is_favourite);
  const [zone, setZone] = useState(props.zone);
  const [zoneEvents, setZoneEvents] = useState(props.events_info ? props.events_info.events : [] || []);
  const [zoneImage, setZoneImage] = useState(null);
  const [zoneEventCounts, setZoneEventCounts] = useState(props.events_info ? props.events_info.counts : { alert: 0, warning: 0 } || { alert: 0, warning: 0 });
  const [turnOnVideoStreaming, setTurnOnVideoStreaming] = useState(false);
  const [user, setUser] = useState(sessionMgr.readCookie('user'));

  let faIcons = { 'temperature': 'fa-thermometer-half', 'humidity': 'fa-tint', 'motion': 'fa-street-view', 'motion_security': 'fa-street-view text-danger', 'motion_ahours': 'fa-street-view', 'co': 'fa-info-circle', 'voc': 'fa-info-circle' };

  useEffect(() => {
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 2000);
    setUser(sessionMgr.readCookie('user'));
    setZone(props.zone);
    setZoneEvents(props.events_info ? props.events_info.events : [] || []);
    setZoneEventCounts(props.events_info ? props.events_info.counts : { alert: 0, warning: 0 } || { alert: 0, warning: 0 });
  }, [props]);

  const showZoneHistory = () => {
    $('[data-toggle="tooltip"]').tooltip('hide');
    var sessionMgr = new SessionManager();
    var user = sessionMgr.readCookie('user');
    user.zone_selected = zone;
    sessionMgr.storeCookie('user', user);
    ReactGA.event({
      category: 'Navigation',
      action: 'Clicked Zone',
      label: 'Zone  ' + zone.location_name
    });
    window.location = '/dashboard/zone-history';
  }

  const fetchZoneHistory = () => {
    setZoneImage(no_image);
    //console.log('Fetching latest available image for - ' + zone.location_name + '(' + zone.location_id + ')');
    //console.log('Curr Url - ' + zone.image);

    var data = {
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      location_id: zone.location_id,
      sec_timestamp: zone.location_last_pic_time
    }

    $.ajax(
      {
        url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/latest-location-image',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          if (res.data && res.data.signedUrl) {
            var sessionMgr = new SessionManager();
            var user = sessionMgr.readCookie('user');
            for (let z of user.zones) {
              if (z.location_id === zone.location_id) {
                z.image = res.data.signedUrl;
                //console.log('New Url - ' + z.image);
                break;
              }
            }
            sessionMgr.storeCookie('user', user);
            setZoneImage(res.data.signedUrl);
          }
        }
      }
    );
  }

  const captureOndemandPhoto = async (id) => {
    let device_iotname = null;
    if (zone.location_device_type === 'uniview') {
      let deviceObj = await CommonUtils.getDevice(zone.device_id, user);
      device_iotname = deviceObj ? deviceObj.device_iotname : null;
    }

    var data = {
      user_login: user.user_login,
      user_token: user.user_token,
      form_input: { operation: "on-demand-snap", device_id: zone.device_id, device_type: zone.location_device_type, device_iotname: device_iotname }
    }

    $.ajax(
      {
        url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/live-camera-feed',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
      }
    ).then((res) => {
      if (res && res.status && res.status.code === 200) {
        ondemandPhotoSnapStatus(id);
      }
    })
  }

  const ondemandPhotoSnapStatus = async (id) => {
    let device_iotname = null;
    if (zone.location_device_type === 'uniview') {
      let deviceObj = await CommonUtils.getDevice(zone.device_id, user);
      device_iotname = deviceObj ? deviceObj.device_iotname : null;
    }

    var data = {
      user_login: user.user_login,
      user_token: user.user_token,
      form_input: { operation: "on-demand-snap-status", device_id: zone.device_id, device_type: zone.location_device_type, device_iotname: device_iotname }
    }

    $.ajax(
      {
        url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/live-camera-feed',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
      }
    ).then((res) => {
      if (res && res.status && res.status.code === 200) {
        let status = res.data.thing_shadow.state.desired.camera_snap;
        if (status === true || status === zone.device_id) {
          $(`#${id}`).html('Capturing Photo...');
          $(`#${id}`).prop('disabled', true);
          setTimeout(() => {
            ondemandPhotoSnapStatus(id);
          }, zone.location_device_type && zone.location_device_type === 'uniview' ? 5000 : 2000);
        }
        else {
          props.fetchLocations(id);
          setTimeout(() => {
            $(`#${id}`).html('OnDemand Photo');
            $(`#${id}`).prop('disabled', false);
            props.fetchLocations(id);
          }, 3000);
        }
      }
    })
  }

  const fetchLatestImage = (zone) => {

    $(`#${zone.location_id}`).html('Capturing Photo...');
    $(`#${zone.location_id}`).prop('disabled', true);
    $.ajax(
      {
        url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/latest-image",
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify({
          device_id: zone.device_id,
          location_id: zone.location_id,
          site_id: zone.site_id,
          customer_id: zone.customer_id,
        })
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          props.fetchLocations(zone.location_id);
          setTimeout(() => {
            $(`#${zone.location_id}`).html('OnDemand Photo');
            $(`#${zone.location_id}`).prop('disabled', false);
            props.fetchLocations(zone.location_id);
          }, 3000);
        }
      },
      (res) => {
      });
  }

  const getPopoverContent = (event_level) => {
    let filteredEvents = zoneEvents.filter(z => z.event_level === event_level);
    return filteredEvents.map((zone_event, z) => (
      <div className="bg-lighter p-2 border-rounded event-info-alert mb-2 font-size-12" key={z}>
        <div>
          <span className="font-weight-bold text-capitalize">
            <i className={"fa " + faIcons[zone_event.sensor_id.split(':')[0]] + ' event-' + zone_event.event_level}></i> {zone_event.sensor_id.split(':')[0]}
          </span>
          <span className="pull-right">
            <Moment format="MMM DD, YYYY HH:mm" tz={props.site.site_iana_timezone}>
              {zone_event.timestamp}
            </Moment>
          </span>
        </div>
        <div className="text-capitalize mt-2">{zone_event.event_message}</div>
      </div>
    ));
  }

  const loadActualImage = (imgSourceUrl) => {
    setTimeout(() => {
      if (imageRef && imageRef.current) {
        if (user.user_role === 202 && zone.location_device_type === 'axis') {
          if (zone.preset && zone.location_operstatus !== 'Disconnected') {
            if (zone.preset.length === 0) {
              imageRef.current.src = default_preset
            } else {
              imageRef.current.src = imgSourceUrl
            }
          } else {
            imageRef.current.src = no_image
          }
        } else {
          imageRef.current.src = imgSourceUrl // For better image experience.
        }
      }
      else
        loadActualImage(imgSourceUrl)
    }, 10);
  }

  const copyStreamLink = () => {
    let stream_parts = ['stream.' + user.site_selected.customer_id, 'sitekick', zone.device_id, user.site_selected.site_id, zone.location_id];
    let stream_link = window.location.origin + '/live-stream/' + filterAlphanumeric(zone.location_name.trim()) + '?type=' + zone.location_device_type + '&token=' + encodeURIComponent(LZString.compressToBase64(stream_parts.join(' ')));

    navigator.clipboard.writeText(stream_link).then(function () {
      Toastr.info('Stream link copied to clipboard!');
    });
  }

  const filterAlphanumeric = (str) => {
    return str.replace(/[^A-Za-z0-9]/g, '_');
  }

  useEffect(() => {
    if (turnOnVideoStreaming) {
      setTimeout(() => {
        $(".ant-modal-header").css('padding', '0px');
        $('.ant-modal-wrap').addClass('modal fade show');
        $('.ant-modal-content').css({ "bottom": "36px" });
      }, 100);
    }
  }, [turnOnVideoStreaming]);

  const streamVideo = () => {
    setTurnOnVideoStreaming(true);
  }

  const toggleFavouriteSitesForLeadership = async () => {
    let customer_id = user.customer_id || user.site_selected.customer_id;
    let site_id = zone.site_id;
    let location_id = zone.location_id;

    let _c = await CommonUtils.getCustomer(customer_id, user);
    let fav = true; //
    setFavorite(fav);

    if (_c.leadership_sites) {
      let c = _c.leadership_sites;
      if (c[site_id]) {
        if (c[site_id].includes(location_id)) {
          let new_sites = c[site_id].filter(function (item) {
            return item !== location_id
          });
          c[site_id] = new_sites;
          fav = false;
        } else {
          c[site_id].push(location_id);
        }
      } else {
        c[site_id] = [location_id];
      }
      _c.leadership_sites = c;
    } else {
      _c.leadership_sites = { [site_id]: [location_id] };
    }

    setFavorite(false);
    let result = await CommonUtils.saveCustomer({ customer_id: customer_id, leadership_sites: _c.leadership_sites }, user);

    if (result) {
      Toastr.info('<b>' + zone.location_name + '</b>' + (fav ? ' added to' : ' removed from') + ' executive dashboard successfully!');
    }
  }

  let enable_view_streaming = user && user.site_selected && (user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming);

  const counts = zoneEventCounts;
  const imgSourceUrl = zoneImage ? zoneImage : zone.image;

  useEffect(() => {
    if (imgSourceUrl)
      loadActualImage(imgSourceUrl);
  }, [imgSourceUrl]);
  var temperature = Math.round(zone.location_temperature, 2);
  temperature = temperature === -100 ? '' : temperature;

  var humidity = Math.round(zone.location_humidity, 2);
  humidity = humidity === -100 ? '' : humidity;

  let enable_live_mode = zone.device_id && zone.location_operstatus === 'Connected';
  if (enable_live_mode)
    enable_live_mode = ((zone.location_features && zone.location_features.includes('s1')) || (['axis', 'uniview'].includes(zone.location_device_type)));

  let enable_ondemand_photo = zone.device_id && zone.location_operstatus === 'Connected';
  if (enable_ondemand_photo)
    enable_ondemand_photo = (zone.location_features && zone.location_features.includes('s1')) || zone.location_device_type;
  let checkPreset = zone.location_device_type === 'axis' ? zone.preset && zone.preset.length > 0 : true;
  let zoneHistoryLink = user.user_role === 202 ? (checkPreset ? null : streamVideo) : (props.do_not_navigate ? null : showZoneHistory);

  let streaming = props.do_not_navigate === true ? false : true;
  let isPublicStreamAllowed = false;
  let isInstallerUser = checkPreset === false && user.user_role === 202;
  try {
    let isLegacyCamWithPublicStream = zone.location_device_type && zone.location_device_type === zone.device_id;
    isPublicStreamAllowed = isLegacyCamWithPublicStream || zone.location_config.feature_controls.public_stream.enabled;
  } catch (error) { }

  const sendAck = (action = 'acknowledge', val = zone.location_lastupdate) => {
    $('[data-toggle="tooltip"]').tooltip('hide');
    $('[data-toggle="tooltip"]').tooltip('dispose');
    $.ajax({
      url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location/modify',
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify({
        user_login: user.user_login,
        user_token: user.user_token,
        form_input: {
          location_name: zone.location_name,
          site_id: zone.site_id,
          location_id: zone.location_id,
          location_lastupdate: val,
          [action]: true
        }
      })
    }).then((res) => {
      if (res && res.status && res.status.code === 200) {
        setZone(prevZone => ({
          ...prevZone,
          ...res.data.Attributes
        }));
      }
    });
  };

  const isInactivityNotified = zone.acknowledge === zone.location_lastupdate || zone.contact_support === zone.location_lastupdate;
  const isRecallAllowed = zone.inactivity_reported_by === user.user_login || [99, 98].includes(user.user_role);

  setTimeout(() => {
    $('[data-toggle="tooltip"]').tooltip();
  }, 1000);

  //console.log(zone.location_name + ' --- ' + [zone.location_device_type, isPublicStreamAllowed, user.user_role !== 202, zone.location_operstatus === 'Connected'])

  return (
    <React.Fragment>
      <div className="card m-2 bg-shadow">

        <div className="card-body p-0">
          <img ref={imageRef} className={zoneHistoryLink ? "card-img-top img-fluid d-block cursor-pointer " : "card-img-top img-fluid d-block"} src={no_image} alt={zone.location_name} onClick={zoneHistoryLink} onError={fetchZoneHistory.bind()} />
          <div className="card-img-overlay-custom text-right p-1">
            {/* <Modal ref={React.createRef()} id="selectSettingsModal" label={CommonUtils.hasPermission('SITESUPT-UI-VIEW-STREAMING') && streaming === true && checkPreset && <button className={enable_live_mode && enable_view_streaming ? "btn btn-xs btn-danger font-size-12" : "btn btn-xs btn-danger font-size-12 hide"}><i className="fa fa-sm fa-circle pr-1" />View Streaming</button>} size="modal-lg">
                {this.zone.location_device_type ? <AxisLiveCameraFeed zone={this.zone} user={this.state.user}></AxisLiveCameraFeed> : <LiveCameraFeed zone={this.zone} user={this.state.user}></LiveCameraFeed>}
              </Modal> */}
            {CommonUtils.hasPermission('SITESUPT-UI-VIEW-STREAMING') && !isInstallerUser && streaming === true && <button onClick={() => streamVideo()} className={enable_live_mode && enable_view_streaming ? "btn btn-xs btn-danger font-size-12" : "btn btn-xs btn-danger font-size-12 hide"}><i className="fa fa-sm fa-circle pr-1" />View Streaming</button>}
            {zone.location_device_type && isPublicStreamAllowed && user.user_role !== 202 && zone.location_operstatus === 'Connected' && <button onClick={() => copyStreamLink()} className="btn btn-xs btn-primary font-size-12 ml-2">Copy Stream Link</button>}
            {CommonUtils.hasPermission('SITESUPT-UI-ONDEMAND-PHOTO') && <button id={zone.location_id} className={enable_ondemand_photo ? "btn btn-xs btn-primary font-size-12 ml-1" : "btn btn-xs btn-danger font-size-12 hide"} onClick={() => (zone.location_device_type === 'axis' ? fetchLatestImage(zone) : captureOndemandPhoto(zone.location_id))}>OnDemand Photo</button>}

          </div >
        </div >

        <div className="card-header text-app">
          <b className={zoneHistoryLink ? "font-weight-700 cursor-pointer" : "font-weight-700"} >
            <span onClick={zoneHistoryLink}>{zone.location_name}</span> &nbsp;
            {<span data-toggle="tooltip" title={zone.location_operstatus === 'Connected' ? 'Active' : 'Inactive'}><Badge className={zone.location_operstatus === 'Connected' ? "fa fa-lg fa-circle text-success" : "fa fa-lg fa-circle text-danger"}></Badge></span>}
          </b>
          <span className={zone.location_operstatus === 'Connected' ? 'text-success pull-right font-size-12' : 'text-danger pull-right font-size-12'}>
            <span className="text-primary">
              {CommonUtils.formatSensorData('temperature', temperature)}
            </span>
            <span className="ml-3 text-primary">
              {CommonUtils.formatSensorData('humidity', humidity)}
            </span>
          </span>
          <div className="text-dark">
            <span className="font-size-12 font-weight-300">
              <Moment format="MMM DD, YYYY HH:mm" tz={props.site.site_iana_timezone}>
                {zone.location_lastupdate}
              </Moment>
              {CommonUtils.hasPermission('SITESUPT-UI-EDIT-FAV-SITES') && <span className="p-3" onClick={() => toggleFavouriteSitesForLeadership()}><i className={"fa fa-star cursor-pointer " + (isFavourite ? "text-success" : "text-gray")}></i></span>}
            </span>

            <span className="pull-right">
              {counts.warning > 0 && <Popover placement="topRight" content={getPopoverContent('warning')} title="Warnings"><span className="cursor-pointer"><i className="fa fa-exclamation-triangle" style={{ color: 'orange' }}></i><sup><span className="mr-2">{counts.warning}</span></sup></span></Popover>}
              {counts.alert > 0 && <Popover placement="topRight" content={getPopoverContent('alert')} title="Alerts"><span className="cursor-pointer"><i className="fa fa-exclamation-triangle text-danger"></i><sup><span className="mr-2">{counts.alert}</span></sup></span></Popover>}
            </span>
            {
              turnOnVideoStreaming &&
              <Modal
                bodyStyle={{ padding: '0px' }}
                footer={false}
                width={800}
                className="modal-dialog modal-md"
                closable={false}
                okButtonProps={{ visibility: 'hidden' }}
                open={turnOnVideoStreaming}
                onOk={() => setTurnOnVideoStreaming(false)}>
                {zone.location_device_type ? <AxisLiveCameraFeed closeModal={() => setTurnOnVideoStreaming(false)} zone={zone} user={user}></AxisLiveCameraFeed> :
                  <LiveCameraFeed closeModal={() => setTurnOnVideoStreaming(false)} zone={zone} user={user}></LiveCameraFeed>
                }
              </Modal>
            }
          </div>
          {zone.location_operstatus !== 'Connected' &&
            <div className="mt-2">
              {isInactivityNotified ? <span className="cursor-pointer" data-toggle="tooltip" data-placement="right" onClick={() => isRecallAllowed ? sendAck('contact_support', 0) : {}} title={isRecallAllowed ? "Recall this action" : "By " + zone.inactivity_reported_by} >{zone.contact_support === zone.location_lastupdate ? <span className="badge badge-warning mx-2">Contacted Support</span> : <span className="badge badge-warning">Acknowledged</span>}</span> : <></>}
              {!isInactivityNotified && CommonUtils.hasPermission('SITESUPT-UI-INACTIVE-GW-NOTIFY') && <>
                <button className="btn btn-xs btn-warning font-size-12" onClick={() => sendAck()}>Acknowledge</button>
                <button className="btn btn-xs btn-warning mx-2 font-size-12" onClick={() => sendAck('contact_support')}>Contact Support</button>
              </>}
            </div>}
        </div>
      </div >
    </React.Fragment >
  );
}

export default ZoneCard;